import { render, staticRenderFns } from "./CustomerManage.vue?vue&type=template&id=5b3311ec&"
import script from "./CustomerManage.vue?vue&type=script&lang=js&"
export * from "./CustomerManage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerManage.vue?vue&type=style&index=0&id=5b3311ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports